import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("MachineTaskView Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Wystąpił błąd!</h4>
          <p>
            Nie udało się załadować panelu sterowania maszyną. 
            Spróbuj odświeżyć stronę lub skontaktuj się z administratorem.
          </p>
          <hr />
          <p className="mb-0">
            Szczegóły błędu: {this.state.error && this.state.error.message ? this.state.error.message : "Nieznany błąd"}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
